import { render, staticRenderFns } from "./PaystackModal.vue?vue&type=template&id=531fc0d0&"
import script from "./PaystackModal.vue?vue&type=script&lang=js&"
export * from "./PaystackModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports